// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"expired-wwc__wrapper--2pm9H","message":"expired-wwc__message--1l2t1"};